import React from 'react';
import {ReactComponent as Icon} from 'images/icon/bookmark.svg';

export default class BookmarkIcon extends React.PureComponent {
  render() {
    return <Icon className="icon bookmark" onClick={this.props.onClick} />;
  }
}
